<div class="hard-skills-tree" id="hard-skills-tree"
  [resizeListener]="{ width: 460, class: 'is-mobile' }">

  <notify-popup
    *ngIf="seniorityChangeNotify && seniorityChangeNotify.change"
    (onChanged)="seniorityChangeConfirm($event, seniorityChangeNotify.change)"
    [cancelLabel]="'Common.No' | translate"
    [okLabel]="'Common.Yes' | translate"
    [title]="'HardSkillsTree.WarningSeniorityChange' | translate"
    [msg]="'HardSkillsTree.SeniorityChangeMessage' | translate">
  </notify-popup>

  <notify-popup
    *ngIf="seniorityChangeNotify && seniorityChangeNotify.reset"
    (onChanged)="seniorityChangeConfirm($event, null)"
    [cancelLabel]="'Common.No' | translate"
    [okLabel]="'Common.Yes' | translate"
    [title]="'HardSkillsTree.WarningResetSkills' | translate"
    [msg]="'HardSkillsTree.ResetSkillsMessage' | translate">
  </notify-popup>

  <div class="hard-skills-tree__tabs">
    <div class="hard-skills-tree__tabs__item"
      [class.is-active]="currentTab === 'preset'"
      (click)="selectTab('preset')">
      {{ 'HardSkillsTree.SkillPreset' | translate }}
    </div>
    <!-- <div class="hard-skills-tree__tabs__item" 
      [class.is-active]="currentTab === 'all'"
      (click)="selectTab('all')">
      {{ 'HardSkillsTree.AllSkills' | translate }}
    </div> -->
  </div>

  <div class="hard-skills-tree__single-skill-bg" *ngIf="singleSkillControl" (click)="closeSingleSkill(false)"></div>
  <div class="hard-skills-tree__single-skill" *ngIf="singleSkillControl">
    <i class="app-ico-mask app-ico-mask__x" (click)="closeSingleSkill(false)"></i>
    <skill-range-selector
      [control]="singleSkillControl"
      [mustHave]="mustHave"
      [tradeOffMax]="singleTradeOffMax"
      [tradeOffSelected]="singleTradeOffSelected"
      [selectedBranch]="singleSelectedBranch && singleSelectedBranch.name ? singleSelectedBranch.name : null"
      [noShadow]="true"
      [jobTitle]="jobTitle"
      [seniority]="senioritySelected">
    </skill-range-selector>
    <div class="hard-skills-tree__single-skill__btns">
      <div class="is-btn is-btn__outfill" (click)="closeSingleSkill(false)">{{ 'HardSkillsTree.Cancel' | translate }}</div>
      <div class="is-btn" (click)="closeSingleSkill()">{{ 'HardSkillsTree.Save' | translate }}</div>
    </div>
  </div>

  <ng-container *ngIf="currentTab === 'preset'">
    <div class="hard-skills-tree__preset a-section">
      <div class="a-section__inner">
        <div class="hard-skills-tree__preset__header">
          <a-select
            *ngIf="showSetSeniority && seniorityChangeNotify"
            [label]="'HardSkillsTree.SelectSeniority' | translate"
            [useLables]="true"
            [enableSearch]="false"
            [items]="seniorityList"
            [control]="seniorityControl"
            (onValueChanged)="seniorityChange($event)">
          </a-select>
          <div class="is-oneline">
            <skills-search-input
              [label]="'HardSkillsTree.AddNewSkill' | translate"
              [items]="searchSkillsList"
              [control]="searchGlobalForm"
              (skillChanged)="skillChanged($event)">
            </skills-search-input>
            <div class="is-btn is-btn__outfill" 
              [class.is-disabled]="!skillSetWasChanged"
              (click)="seniorityChange()">
              <i class="app-ico-mask app-ico-mask__reset"></i>
            </div>
          </div>
        </div>
        <div class="hard-skills-tree__preset__loader" @opacityInOut *ngIf="presetIsLoading">
          <div class="round-loader is-trans"></div> {{ 'HardSkillsTree.LoadingSkills' | translate }}
        </div>
        <div class="hard-skills-tree__preset__list" [class.is-hidden]="presetIsLoading">
          <h4 *ngIf="mustHave && mustHaveSkills.length">{{ 'HardSkillsTree.MustHave' | translate }}</h4>
          <div class="hard-skills-tree__preset__item" 
            *ngFor="let item of mustHaveSkills"
            [class.is-deleted]="item.skill.id === deleteId">
            <div class="hard-skills-tree__preset__item__inner">
              <i *ngIf="!item.skill.isRequired" class="is-dot"></i>
              <i *ngIf="item.skill.isRequired" class="app-ico-mask app-ico-mask__pin" [title]="'SkillRange.ExcludeCandidatesLackingSkill' | translate"></i>
              <span class="is-link" (click)="skillChanged(item)">
                {{ item.skill.name }}
              </span>
              <span class="is-years" *ngIf="item.skill.years"> 
                - {{ item.skill.years }} {{ item.skill.years === 1 ? ('HardSkillsTree.Yr' | translate) : ('HardSkillsTree.Yrs' | translate) }}
              </span>
              <i class="app-ico-mask app-ico-mask__x" (click)="addRemoveSkill(item.skill, false, 150)"></i>
            </div>
            <div class="is-exp-dots">
              <span *ngFor="let e of [].constructor(5); let i = index"
                [class.is-active]="i < item.skill.experience">
              </span>
            </div>
          </div>

          <ng-container *ngIf="mustHave && shouldHaveSkills.length">
            <h4>{{ 'HardSkillsTree.ShouldHave' | translate }}</h4>
            <div class="hard-skills-tree__preset__item" 
              *ngFor="let item of shouldHaveSkills"
              [class.is-deleted]="item.skill.id === deleteId">
              <div class="hard-skills-tree__preset__item__inner">
                <i *ngIf="!item.skill.isRequired" class="is-dot"></i>
                <i *ngIf="item.skill.isRequired" class="app-ico-mask app-ico-mask__info" [title]="'SkillRange.ExcludeCandidatesLackingSkill' | translate"></i>
                <span class="is-link" (click)="skillChanged(item)">
                  {{ item.skill.name }}
                </span>
                <span class="is-years" *ngIf="item.skill.years"> 
                  - {{ item.skill.years }} {{ item.skill.years === 1 ? ('HardSkillsTree.Yr' | translate) : ('HardSkillsTree.Yrs' | translate) }}
                </span>
                <i class="app-ico-mask app-ico-mask__x" (click)="addRemoveSkill(item.skill, false, 150)"></i>
              </div>
              <div class="is-exp-dots">
                <span *ngFor="let e of [].constructor(5); let i = index"
                  [class.is-active]="i < item.skill.experience">
                </span>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="mustHave && couldHaveSkills.length">
            <h4>{{ 'HardSkillsTree.CouldHave' | translate }}</h4>
            <div class="hard-skills-tree__preset__item" 
              *ngFor="let item of couldHaveSkills"
              [class.is-deleted]="item.skill.id === deleteId">
              <div class="hard-skills-tree__preset__item__inner">
                <i *ngIf="!item.skill.isRequired" class="is-dot"></i>
                <i *ngIf="item.skill.isRequired" class="app-ico-mask app-ico-mask__info" [title]="'SkillRange.ExcludeCandidatesLackingSkill' | translate"></i>
                <span class="is-link" (click)="skillChanged(item)">
                  {{ item.skill.name }}
                </span>
                <span class="is-years" *ngIf="item.skill.years"> 
                  - {{ item.skill.years }} {{ item.skill.years === 1 ? ('HardSkillsTree.Yr' | translate) : ('HardSkillsTree.Yrs' | translate) }}
                </span>
                <i class="app-ico-mask app-ico-mask__x" (click)="addRemoveSkill(item.skill, false, 150)"></i>
              </div>
              <div class="is-exp-dots">
                <span *ngFor="let e of [].constructor(5); let i = index"
                  [class.is-active]="i < item.skill.experience">
                </span>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="mustHave && niceHaveSkills.length">
            <h4>{{ 'HardSkillsTree.NiceToHave' | translate }}</h4>
            <div class="hard-skills-tree__preset__item" 
              *ngFor="let item of niceHaveSkills"
              [class.is-deleted]="item.skill.id === deleteId">
              <div class="hard-skills-tree__preset__item__inner">
                <i *ngIf="!item.skill.isRequired" class="is-dot"></i>
                <i *ngIf="item.skill.isRequired" class="app-ico-mask app-ico-mask__info" [title]="'SkillRange.ExcludeCandidatesLackingSkill' | translate"></i>
                <span class="is-link" (click)="skillChanged(item)">
                  {{ item.skill.name }}
                </span>
                <span class="is-years" *ngIf="item.skill.years"> 
                  - {{ item.skill.years }} {{ item.skill.years === 1 ? ('HardSkillsTree.Yr' | translate) : ('HardSkillsTree.Yrs' | translate) }}
                </span>
                <i class="app-ico-mask app-ico-mask__x" (click)="addRemoveSkill(item.skill, false, 150)"></i>
              </div>
              <div class="is-exp-dots">
                <span *ngFor="let e of [].constructor(5); let i = index"
                  [class.is-active]="i < item.skill.experience">
                </span>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="mustHave && lowPrioritySkills.length">
            <h4>{{ 'HardSkillsTree.LowPriority' | translate }}</h4>
            <div class="hard-skills-tree__preset__item" 
              *ngFor="let item of lowPrioritySkills"
              [class.is-deleted]="item.skill.id === deleteId">
              <div class="hard-skills-tree__preset__item__inner">
                <i *ngIf="!item.skill.isRequired" class="is-dot"></i>
                <i *ngIf="item.skill.isRequired" class="app-ico-mask app-ico-mask__info" [title]="'SkillRange.ExcludeCandidatesLackingSkill' | translate"></i>
                <span class="is-link" (click)="skillChanged(item)">
                  {{ item.skill.name }}
                </span>
                <span class="is-years" *ngIf="item.skill.years"> 
                  - {{ item.skill.years }} {{ item.skill.years === 1 ? ('HardSkillsTree.Yr' | translate) : ('HardSkillsTree.Yrs' | translate) }}
                </span>
                <i class="app-ico-mask app-ico-mask__x" (click)="addRemoveSkill(item.skill, false, 150)"></i>
              </div>
              <div class="is-exp-dots">
                <span *ngFor="let e of [].constructor(5); let i = index"
                  [class.is-active]="i < item.skill.experience">
                </span>
              </div>
            </div>
          </ng-container>

          <div class="hard-skills-tree__preset__no-skills" *ngIf="!mustHaveSkills.length && !niceHaveSkills.length && !shouldHaveSkills.length && !couldHaveSkills.length && !lowPrioritySkills.length">
            <b>{{ 'HardSkillsTree.NoSkillsSelected' | translate }}</b>, {{ 'HardSkillsTree.NoSkillsMessage' | translate }}
          </div>

          <!-- Legend for Required Skills -->
          <div class="hard-skills-tree__preset__legend" *ngIf="mustHaveSkills.length || niceHaveSkills.length || shouldHaveSkills.length || couldHaveSkills.length || lowPrioritySkills.length">
            <i class="app-ico-mask app-ico-mask__pin"></i>
            <span>{{ 'SkillRange.ExcludeCandidatesLackingSkill' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="currentTab === 'all'">
    <div class="hard-skills-tree__breadcrumbs">
      <span class="hard-skills-tree__breadcrumbs__item">
        {{ jobTitle }}
      </span>
      <i class="app-ico-mask app-ico-mask__point"></i>
      <span class="hard-skills-tree__breadcrumbs__item"
        (click)="selectSkill(null)"
        [class.is-link]="activeSkill">
        {{ 'HardSkillsTree.Skills' | translate }}
      </span>
      <i class="app-ico-mask app-ico-mask__point" *ngIf="activeSkill"></i>
      <span class="hard-skills-tree__breadcrumbs__item is-link has-dropdown" *ngIf="activeSkill">
        <span class="has-dropdown__click-area" (click)="showMenuSkills()">
          {{ activeSkill.name }} <i class="app-ico-mask app-ico-mask__select-arrow-down"></i>
        </span>
        <div class="has-dropdown__bg" *ngIf="showSkillsMenu" (click)="selectMenuSkill(null)"></div>
        <div class="has-dropdown__menu" *ngIf="showSkillsMenu">
          <div class="has-dropdown__menu__item" 
            *ngFor="let mainSkills of allSkills"
            (click)="mainSkills.id !== activeSkill.id && selectMenuSkill(mainSkills)"
            [class.is-active]="mainSkills.id === activeSkill.id">
            {{ mainSkills.name }}
          </div>
        </div>
      </span>
    </div>

    <div class="hard-skills-tree__search" *ngIf="currentViewSkills.length">
      <div *ngIf="activeSkill" class="is-btn is-btn__outfill" (click)="selectSkill(null)">
        <i class="app-ico-mask app-ico-mask__btn-arrow-left"></i>
        <span>{{ 'HardSkillsTree.AllSkills' | translate }}</span>
      </div>
      <skills-search-input
        [label]="'HardSkillsTree.SearchSkills' | translate"
        [items]="searchSkillsList"
        [control]="searchGlobalForm"
        (skillChanged)="skillChanged($event)">
      </skills-search-input>
    </div>

    <!-- <notify-popup
      *ngIf="removeSkillNotify"
      (onChanged)="removeSkillResult($event)"
      [cancelLabel]="'No'"
      [okLabel]="'Yes'"
      [msg]="'Are you sure you want to remove skills?'">
    </notify-popup> -->

    <div class="hard-skills-tree__tree"
      [ngStyle]="{ 'opacity': mainLoading ? 0 : 1 }"
      [class.has-mobile-slider]="totalPages > 1"
      *ngIf="!activeSkill && currentViewSkills.length" @slideInOut>
      <div class="hard-skills-tree__tree__center">
        <ng-container *ngIf="totalPages > 1">
          <i class="app-ico-mask app-ico-mask__btn-arrow-left" 
            (click)="(activePages - 1) !== 0 && switchPage(-1)"></i>
          <b>{{ activePages }}</b> <span>/</span> {{ totalPages }}
          <i class="app-ico-mask app-ico-mask__btn-arrow-right" 
            (click)="activePages !== totalPages && switchPage(1)"></i>
        </ng-container>
        <div class="hard-skills-tree__tree__center__no-slider" *ngIf="totalPages <= 1"></div>
      </div>

      <div class="hard-skills-tree__tree__bg"
        [ngClass]="currentViewSkills.length ? 'count-' + currentViewSkills.length : ''"
        [class.loading]="loading">
        <div class="hard-skills-tree__tree__item"
          *ngFor="let branch of currentViewSkills;"
          [class.has-selected]="selectedCount(branch.id)"
          (click)="selectSkill(branch)">
          <div>
            {{ branch.name }}
            <div class="skills-count" [class.loading]="subLoading" *ngIf="selectedCount(branch.id)">
              {{ selectedCount(branch.id) }} {{ selectedCount(branch.id) === 1 ? ('HardSkillsTree.Skill' | translate) : ('HardSkillsTree.SkillsPlural' | translate) }}
            </div>
            <i class="app-ico-mask app-ico-mask__btn-arrow-right"></i>
            <!-- <div class="inner-tree"
              *ngIf="branch.skills && branch.skills.length"
              [ngClass]="branch.skills.length 
                ? branch.skills.length > 5 ? 'inner-count-5' : 'inner-count-' + branch.skills.length
                : ''"
              [class.loading]="subLoading">
              <ng-container *ngFor="let skill of branch.skills; let i = index;">
                <div [class.is-active]="skill.experience" *ngIf="i < 5"></div>
              </ng-container>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="hard-skills-tree__tech" *ngIf="activeSkill" @dropDown>
      <div class="hard-skills-tree__tech__no-skills" *ngIf="!activeSkill.skills || !activeSkill.skills.length">
        {{ 'HardSkillsTree.NoSkillsAvailable' | translate }}
      </div>
      <div *ngIf="activeSkill.skills && activeSkill.skills.length">

        <!-- <div class="hard-skills-tree__tech__search anim-item"
          [class.has-counter]="showViewedCounter">
          <div class="is-btn is-btn__outfill" (click)="selectSkill(null)">
            <i class="app-ico-mask app-ico-mask__btn-arrow-left"></i>
            All skills
          </div>
          <a-input type="text" label="Search" [control]="searchForm" [isSearch]="true"></a-input>
        </div> -->

        <div class="hard-skills-tree__tech__trade-off anim-item" *ngIf="!noSkillsFound">
          {{ tradeOffMax }}/{{ activeSkill.skills.length }} {{ 'HardSkillsTree.TradeOffInfo' | translate }}
          <i class="app-ico-mask app-ico-mask__info"></i>
        </div>
        
        <div class="hard-skills-tree__tech__no-skills" *ngIf="noSkillsFound">{{ 'HardSkillsTree.NoSkillsFound' | translate }}</div>

        <ng-container *ngFor="let tech of techForm.controls; let i = index;">
          <skill-range-selector
            [control]="$any(tech)"
            [tradeOffMax]="tradeOffMax"
            [tradeOffSelected]="tradeOffSelected"
            [searchTerm]="searchTerm"
            [mustHave]="mustHave"
            (skillsToStore)="skillsToStore()"
            [seniority]="senioritySelected">
          </skill-range-selector>
        </ng-container>

        <div class="hard-skills-tree__tech__all-skills-btn">
          <div class="is-btn is-btn__outfill" (click)="selectSkill(null)">{{ 'HardSkillsTree.AllSkills' | translate }}</div>
        </div>

      </div>
    </div>
  </ng-container>
</div>